
import { useAsync, useContext, ref, onMounted, useRoute } from '@nuxtjs/composition-api';
import useTlmCart from '@/composable/useTlmCart';
import useShoppingList from '@/composable/useShoppingList';
import useCheckout from '@/composable/checkout/useCheckout';
export default {
  setup() {
    const route = useRoute()
    const loadShoppingListSteps = ref(false)
    const { app } = useContext()
    const { loadShoppingList, shoppingListExists, shoppingList } = useShoppingList(app)
    const { subscriptionList } = useTlmCart(app)
    const { checkoutType } = useCheckout(app)
    useAsync(async () => {
      if (shoppingListExists.value) {
        await loadShoppingList()
        loadShoppingListSteps.value = true
      }
    }, 'family-abonnement-checkout')
    // eslint-disable-next-line complexity
    onMounted(() => {
      let checkoutMenuActive = 'noFlow'
      if (route.value.path === '/shopkoeb') {
        if (checkoutType.value === 'flowWithMobileVoiceSubscriptionOnly') {
          checkoutMenuActive = subscriptionList?.value?.cartProduct?.additionalBillingInformation?.bundleType === 'MEDIA' ? 'Telmore Play' : 'Mobilabonnement---undermenu'
        } else if (checkoutType.value === 'flowWithDeviceAndSubscription' || checkoutType.value === 'flowWithoutSubscription') {
          checkoutMenuActive = 'Mobiler og tilbehør'
        } else if (checkoutType.value === 'flowWithMobileBroadBandSubscription') {
          checkoutMenuActive = 'Internet'
        }
        const ele = document.getElementById('checkoutMenuItem-' + checkoutMenuActive.replaceAll(' ', '-'))
        ele?.classList?.add('is-active')
      }
    })
    return {
      shoppingList,
      loadShoppingListSteps
    }
  }
}
